export const collectionListItemTestId = 'collectionListItemTestId';
export const collectionListLoadingTestId = 'collectionListLoading';
